<script>
export default {
  props: {
    message: String,
  },
};
</script>

<template>
  <div class="container">
    <b-row>
      <b-col>
        <h1 class="font-weight-medium text-center">
          {{ message }}
        </h1>
      </b-col>
    </b-row>
    <b-row class="justify-content-center">
      <b-col cols="6">
        <img
          src="@/assets/images/error-img.png"
          alt="error image"
          class="img-fluid"
        />
      </b-col>
    </b-row>
  </div>
</template>